export enum ResumeStateEnum {
    WIZARD = 'WIZARD',
    CONSENT = 'CONSENT',
    SINGLE_COMMENT = 'SINGLE_COMMENT',
    QUESTIONNAIRE = 'QUESTIONNAIRE',
    OVERVIEW = 'OVERVIEW'
}
